import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {firestorePlugin} from 'vuefire'

Vue.config.productionTip = false

// change to new Polaris
// import PolarisVue from '@eastsideco/polaris-vue';

// Recommended: import the correct CSS for the version of Polaris the library uses.
// import '@eastsideco/polaris-vue/lib/polaris-vue.css';

import PolarisVue from '@hulkapps/polaris-vue';
import '@hulkapps/polaris-vue/dist/polaris-vue.css';


// Register the plugin with Vue
Vue.use(PolarisVue);
Vue.use(firestorePlugin)

new Vue( {
  router,
  render: h => h(App)
}).$mount('#app')
 